import React from "react";
import { Layout, Heading, TabHeader, Text, Button } from "@netapp/bxp-design-system-react";
import { trackEvent } from "utils/mrTracker";
import { useLocation } from "react-router";
import { appComponents as i18nNamespace } from "../../../i18n/namespace";
import { useTranslation } from "react-i18next";

const TranslationWrapper = ({ children }) => {
    const { t } = useTranslation(i18nNamespace);
  
    return children(t);
};
class ErrorHandler extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        trackEvent({ category: "AppException", action: "MainErrorBoundary", label: error.stack || error.message });
        console.error(error);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.children !== nextProps.children || this.state.hasError !== nextState.hasError || this.state.hasError && this.props.pathname !== nextProps.pathname;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.hasError && prevProps.pathname !== this.props.pathname) {
            this.setState({ hasError: false })
        }
    }

    render() {
        if (this.state.hasError) {
            return <TranslationWrapper>
                {t => <Layout.Page>
                    <TabHeader label="Failed to Render"/>
                    <Layout.Content style={{ padding: "40px 0" }}>
                        <Layout.Column>
                            <Heading level={2}>
                                {t("tab_crashed")}
                            </Heading>
                            <Text>
                                {t("error_printed_console")}
                            </Text>
                            <Text>{t("contact_support")}</Text>
                            {process.env.NODE_ENV === "development" && <Button color="secondary" onClick={() => {
                                this.setState({ hasError: false })
                            }}>
                                {t("reset")}
                            </Button>}
                        </Layout.Column>
                    </Layout.Content>
                </Layout.Page>}
            </TranslationWrapper>
        }

        return this.props.children;
    }
}

const MainErrorBoundary = React.memo(({ children }) => {
    const location = useLocation();
    const { t } = useTranslation(i18nNamespace);

return <ErrorHandler pathname={location.pathname}>
        {children}
    </ErrorHandler>
});

export default MainErrorBoundary;